import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { clearAuthUser } from "../slices/authSlice";

let sessionRevoked = false;

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL,
  prepareHeaders: (headers) => {
    const token = Cookies.get("token") || "";
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("accept", "application/json");
    return headers;
  },
});

export const baseQueryInterceptor: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const url = typeof args === "string" ? args : args.url;

  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const res: any = result.error;

    const publicEndpoints = [
      "/services",
      "/country",
      "/state",
      "/profile-setup",
      "/verify-token",
      "/resend-verification-token",
      "/forgot-password",
      "/resend-otp",
      "/reset-password",
      "/invite",
      "/accept-invite",
      "/reject-invite",
      "/account-types",
      "/login",
      "/register",
    ];

    const isPublicRoute = publicEndpoints.some((endpoint) =>
      url.includes(endpoint)
    );

    if (res.status === 401 && !isPublicRoute && !sessionRevoked) {
      sessionRevoked = true;
      Cookies.remove("token");
      api.dispatch(clearAuthUser());
      localStorage.setItem("fleetrify_logout_reason", "session_revoked");
      toast.warning("Security alert: Your account was signed in from another device. You have been logged out.", {
        duration: 6000,
        position: "top-center",
      });
      setTimeout(() => {
        window.location.href = "/login";
      }, 5000);
    }
  }

  return result;
};

export const baseApi = createApi({
  baseQuery: baseQueryInterceptor,
  reducerPath: "baseApi",
  tagTypes: [
    "users",
    "roles",
    "invited-users",
    "activities",
    "notifications",
    "messages",
    "branches",
    "staffBranches",
    "staff",
    "companies",
    "invites",
    "invite-stats",
    "banks",
    "wallet",
    "transactions",
    "beneficiaries",
    "wallet-preference",
    "companyInfo",
    "companyNotifications",
    "staffNotifications",
    "services",
    "service-types",
    "services-summary",
    "dashboard",
    "countries",
    "states",
    "Fleets",
    "Orders",
    "OnboardingChecklist",
    "OrderRequests",
    "insights",
    "planLimit",
    "companyKyc",
    "RelocationOrders"
  ] as const,
  endpoints: () => ({}),
});